// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCITdRoL3dbBHvx3xliyqnPWWmRC5m_9cc",
  authDomain: "honkai-guide.firebaseapp.com",
  databaseURL: "https://honkai-guide.firebaseio.com/",
  projectId: "honkai-guide",
  storageBucket: "honkai-guide.appspot.com",
  messagingSenderId: "683708108958",
  appId: "1:683708108958:web:391f469e01488a9b576b8f",
};

export default firebaseConfig;
